import { render, staticRenderFns } from "./RmpMasterAccountAccessApplicationBaseStep.vue?vue&type=template&id=6d3355cb&scoped=true"
import script from "./RmpMasterAccountAccessApplicationBaseStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpMasterAccountAccessApplicationBaseStep.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3355cb",
  null
  
)

export default component.exports